/**
 * This class represents the details about the installment plan for a subscription product.
 */
export class ProductInstallmentPlanDetails {
    constructor(commitmentPaymentsCount, subsequentCommitmentPaymentsCount) {
        this.commitmentPaymentsCount = commitmentPaymentsCount;
        this.subsequentCommitmentPaymentsCount = subsequentCommitmentPaymentsCount;
    }
}
//# sourceMappingURL=ProductInstallmentPlanDetails.js.map